import { Children, Fragment, isValidElement, type ReactNode } from 'react'

export const hasValidChildren = (children: ReactNode): boolean => {
  // All children of Children.toArray are "valid children". However, we check the children of
  // Fragments in case the Fragment has no "valid children".

  return Children.toArray(children).some((child) => {
    if (isValidElement(child) && child.type === Fragment) {
      return Children.toArray(child.props.children).some((grandChild) => hasValidChildren(grandChild))
    }
    return true
  })
}
